import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';

import { Field, Fields, reduxForm } from 'redux-form';

import RadioButtonField from 'components/fields/RadioButtonField';
import RadioGroupField from 'components/fields/RadioGroupField';
import DatepickerField from 'components/fields/DatepickerField';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  root: {
  },
  gridItemDatepicker: {
    width: 225,
  },
});

function onChange(values, dispatch, props, previousValues) {
  if (values['Date From']
    && values['Date To']
    && !validate.date(values['Date From'])
    && !validate.date(values['Date To'])) {
    if (!previousValues['Date Range'] && values['Date Range']) {
      props.clearFields(false, false, 'Date From');
      props.clearFields(false, false, 'Date To');
    } else {
      props.clearFields(false, false, 'Date Range');
    }
  }
}

const validateForm = (values) => {
  const errors = {};

  if (!values['Date Range'] && !values['Date From']) {
    errors['Date From'] = 'Field is required';
  }

  if (!values['Date Range'] && !values['Date To']) {
    errors['Date To'] = 'Field is required';
  }

  if (values['Date From'] && !errors['Date From']) {
    errors['Date From'] = validate.date(values['Date From']);
  }

  if (values['Date To'] && !errors['Date To']) {
    errors['Date To'] = validate.date(values['Date To']);
  }

  if (values['Date From']
    && !validate.date(values['Date From'])
    && values['Date To']
    && !validate.date(values['Date To'])
    && moment(values['Date To'], dateFormat).isBefore(moment(values['Date From'], dateFormat))) {
    errors['Date To'] = 'Date To should be after Date From';
  }

  return errors;
};

const EraChartFilterForm = ({
  handleSubmit,
  dateRangeMin,
  dateRangeMax,
  change,
  classes,
}) => (
  <form
    className={classes.root}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Grid
      container
      justify="space-between"
      spacing={16}
    >
      <Grid item>
        <FormControl role="group">
          <Field
            name="Date Range"
            component={RadioGroupField}
          >
            <RadioButtonField
              value="today"
              label="Today"
              size="sm"
              color="primary"
            />
            <RadioButtonField
              value="week"
              label="Past Week"
              size="sm"
              color="primary"
            />
            <RadioButtonField
              value="month"
              label="Past Month"
              size="sm"
              color="primary"
            />
          </Field>
        </FormControl>
      </Grid>
      <Grid item className={classes.gridItemDatepicker}>
        <Fields
          names={[
            'Date From',
            'Date To',
          ]}
          normalize={{
            'Date From': normalize.date,
            'Date To': normalize.date,
          }}
          startDateName="Date From"
          endDateName="Date To"
          component={DatepickerField}
          fullWidth
          minDate={dateRangeMin || '01/01/1900'}
          maxDate={dateRangeMax || moment().format(dateFormat)}
          dateFormat={dateFormat}
          placeholder="mm/dd/yyyy"
          maxLength="10"
          variant="range"
          size="sm"
          color="light"
          rangeButtons
        />
      </Grid>
    </Grid>
  </form>
);

EraChartFilterForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dateRangeMin: PropTypes.string,
  dateRangeMax: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

EraChartFilterForm.defaultProps = {
  dateRangeMin: null,
  dateRangeMax: null,
};

export default reduxForm({
  onChange,
  validate: validateForm,
})(withStyles(styles)(EraChartFilterForm));



// WEBPACK FOOTER //
// ./src/components/home/EraChart/EraChartFilterForm.js